import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, map, Observable, throwError } from 'rxjs';
import { PPUPaginatedSuccessResponse, PPUSuccessResponse } from '../models/response.model';
import { PPUDropOffCreateModel, PPUDropOffModel, PPUDropOffPrintPackageLabelModel, PPUDropOffSendMailModel } from '../models/dropoff.model';
import { FilterModel, TrackingResult } from '../models/common.model';
import FiltersHelper from '../utilities/filters.helper';
import { DatetimeService } from './datetime.service';

@Injectable({ providedIn: 'root' })
export class DropoffService {
  constructor(private http: HttpClient, private datetimeService: DatetimeService) {}

  public getDropOff(ppuLocationId: number, page: number, pageSize: number, filters: FilterModel | null): Observable<any> {
    let queryParams = new HttpParams()
      .set('PPULocationId', ppuLocationId.toString())
      .set('PaginatedQuery.Page', page.toString())
      .set('PaginatedQuery.PageSize', pageSize.toString());

    queryParams = FiltersHelper.getFilterParameters(filters, queryParams);

    return this.http
      .get<PPUPaginatedSuccessResponse<PPUDropOffModel>>(`${environment.API_ROOT}Agent/api/v1/Dropoff/GetDropOff`, {
        params: queryParams,
      })
      .pipe(
        map((res: any) => res),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public addDropOff(ppuLocationId: number, carrier: string, trackingResult: TrackingResult): Observable<any> {
    const requestBody: PPUDropOffCreateModel = {
      ppuLocationId: ppuLocationId,
      carrier: carrier,
      localEventTimeStamp: this.datetimeService.getLocalTime("yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
      packageList: [trackingResult],
    };

    return this.http
      .post<PPUSuccessResponse<PPUDropOffModel>>(`${environment.API_ROOT}Agent/api/v1/Dropoff/AddDropOff`, requestBody)
      .pipe(
        map((res: any) => res),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public sendEmail(packageIds: number[], email: string): Observable<any> {
    const requestBody: PPUDropOffSendMailModel = {
      ID: packageIds.length == 1 ? packageIds[0] : 0,
      Ids: packageIds.length > 1 ? packageIds : [],
      Email: email,
    };

    return this.http
      .post<PPUSuccessResponse<PPUDropOffSendMailModel>>(
        `${environment.API_ROOT}Agent/api/v1/Dropoff/SendMail`,
        requestBody
      )
      .pipe(
        map((res: any) => res),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public sendReceipt(
    ids: number[],
    customerEmail: string,
    customerPhone: string,
    optIn: boolean
  ): Observable<any> {
  
    const requestBody = {
      ids,
      customerEmail,
      customerPhone,
      isSubscribedForNewsletter: optIn
    };
  
    return this.http
      .post<PPUSuccessResponse<any>>(
        `${environment.API_ROOT}Agent/api/v1/Dropoff/SendReceipt`,
        requestBody
      )
      .pipe(
        map(res => res),
        catchError(err => throwError(() => err))
      );
  }

  public printPackageLabel(requestBody: PPUDropOffPrintPackageLabelModel): Observable<any> {
    return this.http
      .post<PPUSuccessResponse<string[]>>(
        `${environment.API_ROOT}Agent/api/v1/Dropoff/PrintPackageLabel`,
        requestBody
      )
      .pipe(
        map((res: any) => res.result),
        catchError((error: any): any => throwError(() => error))
      );
  }

  public pickUpDropoffPackage(ids: number[]): Observable<any> {
    const requestBody = {
      ids
    };

    return this.http
      .post<PPUSuccessResponse<any>>(`${environment.API_ROOT}Agent/api/v1/Dropoff/PickUpDropoff`, requestBody)
      .pipe(
        map((res) => res),
        catchError((error: any): any => throwError(() => error))
      );
  }
}
